export const ZERO_PAD_LENGTH = 2;
